import { get } from '../../helpers/api_helper';

const buildQueryString = (filters) => {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      if (value.length > 0) {
        params.set(key, value.join(','));
      }
      return;
    }

    if (value !== undefined && value !== null && value !== '') {
      params.set(key, value);
    }
  });

  return params.toString();
};

export const getOrderTrendSites = () => get('/api/sales/reports/orders/trend/sites');

export const getOrderTrend = (filters) => (
  get(`/api/sales/reports/orders/trend?${buildQueryString(filters)}`)
);

export default getOrderTrend;
